// O módulo principal inicializa os dados quando carrega ou troca a pessoa.
// Alterar abas/campos não reinicializa o login nem apaga a senha digitada.
export function usePessoaUsuarioModule({ pessoaUsuario, setPessoaUsuario, pessoa, pessoaEmpresas, empresaIds, empresaId }) {
    function change(e) {
        const { name, value, checked, type } = e.target;
        const campo = name.split('.')[1];
        if (!campo) return;
        setPessoaUsuario((prev) => ({ ...prev, [campo]: type === 'checkbox' ? checked : value }));
    }
    return {
        state: { dados: pessoaUsuario, pessoa, pessoaEmpresas, empresaIds, empresaId },
        actions: { change, setDados: setPessoaUsuario },
    };
}
